import { ContentChild, Directive } from '@angular/core'
import { AccordionContentDirective } from './accordion-content.directive.js'
import { AccordionHeaderDirective } from './accordion-header.directive.js'

@Directive({
  selector: 'accordion-item',
  standalone: false,
})
export class AccordionItemDirective {
  @ContentChild(AccordionHeaderDirective) header?: AccordionHeaderDirective
  @ContentChild(AccordionContentDirective) content?: AccordionContentDirective
}
